export type Phase = 0 | 1 | 2 | 3 | 4 | 5 | 6

/**
 * Mind-level session lens chosen at Arrival.
 * - 'standard': default Inner Awakening 6-phase arc (no overrides)
 * - 'the_work': four-question inquiry lens — overrides phase 3 (See) flow,
 *   adds turnaround in phase 4 (Shift)
 * - 'rain':     Recognize → Allow → Investigate → Nurture — overrides phase 2 (Feel) flow
 */
export type SessionMode = 'standard' | 'the_work' | 'rain'

export interface SessionData {
  id: string
  user_id: string
  emotion_label: string
  emotion_intensity: number
  story_text: string
  body_location: string | null
  reminder_text: string | null
  pattern_reflection: string | null
  pattern_confirmed: boolean
  reframe_response: string | null
  choice_text: string | null
  session_summary: string | null
  dominant_theme: string | null
  phase_reached: Phase
  is_complete: boolean
  is_favorite: boolean
  tags: string[]
  created_at: string
}

export interface SessionMessage {
  role: 'user' | 'assistant'
  content: string
}

/**
 * Each step's key under `session.phases` in the locale files.
 *
 * These are keys, not names: the name a person reads comes from
 * t(`session.phases.${PHASE_KEYS[phase]}`). This used to be a table of English
 * names rendered directly, which put "FEEL" and "SEE" at the top of an
 * otherwise Polish session.
 */
export const PHASE_KEYS: Record<Phase, string> = {
  0: 'arrival',
  1: 'ground',
  2: 'feel',
  3: 'see',
  4: 'shift',
  5: 'choose',
  6: 'close',
}
